module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "nighttime-lights-ej--dataset-cover-neworleans.1209360f.jpeg";